import React from 'react'
import PropTypes from 'prop-types'
import ConnectionsIcon from '../Assests/Connections.svg';
import StarIcon from '../Assests/Favorite.png';
import AddUsersIcon from '../Assests/Add User.svg';

const ToggleTypeSelector = ({ TYPE_Items, handleSearchTypeChange, toggleType, requestCount = 0 }) => {
    const getIcon = (type) => {
        if (type === 'All Connections') return <img src={ConnectionsIcon} alt="all" style={{ width: '2.4vh', height: '2.4vh' }} />;
        if (type === 'Favorites') return <img src={StarIcon} alt="favorites" style={{ width: '2.4vh', height: '2.4vh' }} />;
        if (type === 'Requests') return <img src={AddUsersIcon} alt="requests" style={{ width: '2.4vh', height: '2.4vh' }} />;
        return null;
    };
    return (
        <div className='toggle_type_selecter'>
            {TYPE_Items?.map(({ id, type, render }) => (
                <React.Fragment key={id}>
                    <button
                        className={`toggle_search_type_item pointer ${toggleType === type ? "selected_Type" : ""}`}
                        onClick={() => handleSearchTypeChange(type)}
                    >
                        <span style={{ display: 'flex', alignItems: 'center', gap: '0.8vh', fontWeight: 100, fontSize: '1.9vh', letterSpacing: '0.075vh' }}>
                            {type} {render ? render() : getIcon(type)}
                            {type === 'Requests' && requestCount > 0 && (
                                <div style={{
                                    width: '2.6vh',
                                    height: '2.6vh',
                                    borderRadius: '2.8vh',
                                    padding: '0.4vh',
                                    background: '#FF2828',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#fff',
                                    fontSize: '1.2vh',
                                    fontWeight: '600'
                                }}>
                                    {requestCount}
                                </div>
                            )}
                        </span>
                    </button>
                    {id !== TYPE_Items.length - 1 && <div className='toggle_type_separator'></div>}
                </React.Fragment>
            ))}
        </div>
    )
}

ToggleTypeSelector.propTypes = {
    handleSearchTypeChange: PropTypes.func,
    TYPE_Items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            type: PropTypes.string

        })
    ),
    toggleType: PropTypes.string,
    requestCount: PropTypes.number
}

export default ToggleTypeSelector
